import { Box, MenuItem, styled, TextField } from "@material-ui/core";
import {
  EPOCUS_BORDER,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../../../_lib/epocus-palette";
import { MOCK_SCENARIOS } from "../mock-script";

const Bar = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 12,
  padding: "8px 12px",
  backgroundColor: EPOCUS_WHITE,
  borderBottom: `1px solid ${EPOCUS_BORDER}`,
  flexWrap: "wrap",
});

const Label = styled("span")({
  fontSize: rem(12),
  fontWeight: 700,
  color: EPOCUS_TEXT_SECONDARY,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
});

const Description = styled("span")({
  fontSize: rem(12),
  color: EPOCUS_TEXT_SECONDARY,
});

export const ScenarioPicker: FC<{
  scenarioId: string;
  onChange: (scenarioId: string) => void;
}> = ({ scenarioId, onChange }) => {
  const active = MOCK_SCENARIOS.find((s) => s.id === scenarioId);

  return (
    <Bar>
      <Label>Mock agent</Label>
      <TextField
        select
        size="small"
        variant="outlined"
        value={scenarioId}
        onChange={(event) => onChange(event.target.value)}
        inputProps={{ "aria-label": "Mock scenario" }}
      >
        {MOCK_SCENARIOS.map((scenario) => (
          <MenuItem key={scenario.id} value={scenario.id}>
            {scenario.label}
          </MenuItem>
        ))}
      </TextField>
      <Description>{active?.description}</Description>
    </Bar>
  );
};
